import { marginOptions } from '@bm-js/atlascloud-ui'
import Select from './Select'
import RightBarGroup from './RightBarGroup'
import { DynamicContentType, ChangeEvent } from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<{ marginTop?: string; marginBottom?: string }>
  setData: (e: ChangeEvent) => void
  topLine?: boolean
}

const MarginOptions = ({ content, setData, topLine }: Props) => {
  const { tr } = useTr()
  return (
    <RightBarGroup title={tr(TrKey.marginOptionsTitle)} topLine={topLine}>
      <Select
        light
        label={tr(TrKey.marginOptionsTopLabel)}
        desc={tr(TrKey.marginOptionsTopDescription)}
        id='marginTop'
        name='marginTop'
        value={content.data.marginTop}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.marginOptionsPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
      <Select
        light
        label={tr(TrKey.marginOptionsBottomLabel)}
        desc={tr(TrKey.marginOptionsBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.marginOptionsPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </RightBarGroup>
  )
}

export default MarginOptions
